export default function ReviewSection() {
  const reviews = [
    {
      name: "최민수",
      role: "영화 평론가",
      rating: 5,
      comment: "신공은 한국 영화의 새로운 지평을 여는 작품이 될 것입니다. 액션과 드라마의 완벽한 조화, 그리고 인간 본성에 대한 깊이 있는 탐구가 인상적입니다.",
      date: "2025.01.15",
      image: "https://public.readdy.ai/ai/img_res/8fc8d94e05604c5d085cb4b20427c041.jpg"
    },
    {
      name: "정서연",
      role: "독립영화 감독",
      rating: 5,
      comment: "시나리오를 읽고 깊은 감동을 받았습니다. 상업성과 작품성을 모두 갖춘 보기 드문 프로젝트입니다. 제작진의 열정이 느껴집니다.",
      date: "2025.01.12",
      image: "https://readdy.ai/api/search-image?query=creative%20korean%20female%20director%20portrait%20with%20confident%20smile%20wearing%20casual%20artistic%20clothing%20against%20soft%20background%20natural%20lighting%20professional%20headshot&width=600&height=800&seq=review002&orientation=portrait"
    },
    {
      name: "박준영",
      role: "영화 제작자",
      rating: 5,
      comment: "윤준호 배우의 캐스팅은 탁월한 선택입니다. 신공의 세계관과 캐릭터가 완벽하게 구현될 것으로 기대됩니다.",
      date: "2025.01.10",
      image: "https://readdy.ai/api/search-image?query=experienced%20korean%20film%20producer%20portrait%20with%20professional%20demeanor%20wearing%20business%20casual%20attire%20against%20clean%20background%20natural%20studio%20lighting%20confident%20expression&width=600&height=800&seq=review003&orientation=portrait"
    },
    {
      name: "강혜진",
      role: "시나리오 작가",
      rating: 5,
      comment: "인간의 욕망과 배신을 다루는 방식이 매우 섬세하고 설득력 있습니다. 관객들에게 깊은 여운을 남길 작품입니다.",
      date: "2025.01.08",
      image: "https://readdy.ai/api/search-image?query=talented%20korean%20screenwriter%20portrait%20with%20creative%20expression%20wearing%20modern%20casual%20style%20against%20soft%20background%20natural%20lighting%20artistic%20atmosphere&width=600&height=800&seq=review004&orientation=portrait"
    },
    {
      name: "이동훈",
      role: "액션 감독",
      rating: 5,
      comment: "액션 시퀀스 기획안을 보고 놀랐습니다. 한국 영화에서 보기 힘든 스케일과 완성도를 보여줄 것입니다.",
      date: "2025.01.05",
      image: "https://readdy.ai/api/search-image?query=dynamic%20korean%20action%20director%20portrait%20with%20energetic%20expression%20wearing%20casual%20sporty%20attire%20against%20neutral%20background%20natural%20lighting%20professional%20headshot&width=600&height=800&seq=review005&orientation=portrait"
    },
    {
      name: "송미래",
      role: "영화 투자자",
      rating: 5,
      comment: "상업적 가치와 예술적 가치를 모두 갖춘 프로젝트입니다. 투자자로서 신공의 성공을 확신합니다.",
      date: "2025.01.03",
      image: "https://readdy.ai/api/search-image?query=sophisticated%20korean%20film%20investor%20portrait%20with%20professional%20appearance%20wearing%20elegant%20business%20attire%20against%20clean%20background%20natural%20studio%20lighting%20confident%20demeanor&width=600&height=800&seq=review006&orientation=portrait"
    }
  ];

  return (
    <section id="reviews" className="py-32 px-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <p className="text-sm text-amber-600 font-bold tracking-wider uppercase mb-4">
            PROFESSIONAL REVIEWS
          </p>
          <h2 
            className="text-5xl font-black mb-6"
            style={{ fontFamily: "'Noto Serif KR', serif" }}
          >
            업계 전문가들의<br />
            <span className="text-gray-400">평가</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            영화계 전문가들이 신공 프로젝트를 직접 검토하고 남긴 솔직한 평가입니다
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="flex items-start gap-4 mb-6">
                <div className="w-16 h-16 flex items-center justify-center rounded-full overflow-hidden flex-shrink-0">
                  <img 
                    src={review.image} 
                    alt={review.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-gray-900">{review.name}</h3>
                  <p className="text-sm text-gray-500">{review.role}</p>
                  <div className="flex gap-1 mt-2">
                    {[...Array(review.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-amber-500 text-base w-4 h-4 flex items-center justify-center"></i>
                    ))}
                  </div>
                </div>
              </div>
              
              <p className="text-gray-700 leading-relaxed mb-4">
                "{review.comment}"
              </p>
              
              <p className="text-sm text-gray-400">{review.date}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
